// extracted by mini-css-extract-plugin
export default {"optionsContainer":"PartnerServices_optionsContainer__CSK1N"};